import { Locales, LocaleMessages, ServerConfig } from 'shared-types';

interface Params {
  language?: Locales;
  messages: LocaleMessages;
  serverConfig: ServerConfig<'admin'>;
}

const getExcelAchievementsColumnOptions = ({
  language,
  messages,
  serverConfig
}: Params) => {
  const customAttributeOptions: { [key: string]: string } = {};

  const customAttributeKeys = new Set([
    ...(serverConfig.achievementConversationCustomAttributes?.map(
      (attr) => attr.key
    ) || []),
    ...(serverConfig.achievementExternalCustomAttributes?.map(
      (attr) => attr.key
    ) || []),
    ...(serverConfig.achievementMilestoneCustomAttributes?.map(
      (attr) => attr.key
    ) || []),
    ...(serverConfig.achievementTasklistCustomAttributes?.map(
      (attr) => attr.key
    ) || [])
  ]);

  serverConfig.productCustomAttributes
    ?.filter(
      (attr) => customAttributeKeys.has(attr.key) && attr.displayInAnalytics
    )
    .forEach((attr) => {
      customAttributeOptions[`product.customAttributes.${attr.key}`] =
        attr.titleData?.[language || serverConfig.defaultSystemLanguage] ||
        attr.title;
    });

  return {
    'product.title': messages.achievement,
    'product.categories': messages.commonCategories,
    'product.type': messages.commonType,
    'product.externalProvider': messages.achievementExternalProvider,
    'product.externalUrl': messages.achievementExternalUrl,
    'product.workload': `${messages.excelWorkload} (${messages.completionWorkloadHours})`,
    ...(serverConfig.workloadInDays
      ? {
          'product.workloadInDays': `${
            messages.excelWorkload
          } (${messages.commonDays.toLowerCase()})`
        }
      : {}),
    'product.user.addedBy': messages.commonAddedBy,
    'product.user.status': messages.commonStatus,
    'product.user.startedAtDate': messages.commonStartDate,
    'product.user.completionDate': messages.completionsCompletionDate,
    'product.user.expirationDate': messages.commonExpirationDate,
    'product.user.comments': messages.commonComment,
    'product.user.attachments': messages.commonAttachments,
    ...customAttributeOptions,
    'product.customFields': messages.commonCustomFields
  };
};

export default getExcelAchievementsColumnOptions;
